import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib';
import * as actions from './seatmap-result.actions';
import { SeatmapResultState } from './seatmap-result.state';

/**
 * seatmapResult initial state
 */
export const seatmapResultInitialState: SeatmapResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for SeatmapResult Store
 */
export const seatmapResultReducerFeatures: ReducerTypes<SeatmapResultState, ActionCreator[]>[] = [
  on(actions.setSeatmapResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateSeatmapResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetSeatmapResult, () => seatmapResultInitialState),

  on(actions.cancelSeatmapResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failSeatmapResult, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setSeatmapResultFromApi, actions.updateSeatmapResultFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * SeatmapResult Store reducer
 */
export const seatmapResultReducer = createReducer(seatmapResultInitialState, ...seatmapResultReducerFeatures);
